import React, { useEffect } from "react";
import { NumericFormat } from "react-number-format";
import { CMSData } from "@/cms/models";
import { TextField } from "@mui/material";
import { twMerge } from "tailwind-merge";
import { GetFont } from "@/utils/helper";

interface CurrencyInputProps {
  required: boolean;
  label: string;
  defaultValue: number | undefined;
  errors: string[] | undefined;
  name: string;
  className?: string;
  cmsData: CMSData;
}

const CurrencyInput: React.FC<CurrencyInputProps> = ({
  required,
  label,
  defaultValue,
  errors,
  name,
  className = "",
  cmsData,
}) => {
  const style = cmsData.forms.style;
  const fontFamily = GetFont(cmsData.theme.fontType).style.fontFamily;

  useEffect(() => {
    console.log("CurrencyInput", defaultValue);
  }, [defaultValue]);

  const renderTextField = (variant: any) => (
    <div className={twMerge("flex col-span-6 flex-col ", className)}>
      <input name={name} type="number" className="hidden" />
      <NumericFormat
        value={defaultValue}
        onValueChange={(values) => {
          const hiddenInput = document.querySelector(`input[name="${name}"]`);
          if (hiddenInput) {
            (hiddenInput as HTMLInputElement).value = values.value ?? 0;
          }
        }}
        error={!!errors}
        helperText={errors ? errors.join(", ") : undefined}
        customInput={TextField}
        variant={variant}
        required={required}
        suffix=" kr."
        thousandSeparator="."
        decimalSeparator=","
        decimalScale={0}
        allowNegative={false}
        name={`${name}Formatted`}
        label={label}
        slotProps={{
          inputLabel: {
            className: `homepage-text-sm`,
            style: { fontFamily: fontFamily },
          },
          input: {
            className: `${variant === "outlined" ? "bg-white" : ""} homepage-text-sm`,
            style: { fontFamily: fontFamily },
          },
          formHelperText: {
            style: { fontFamily: fontFamily },
          },
        }}
      ></NumericFormat>
    </div>
  );
  switch (style?.type) {
    case "material-outlined":
      return renderTextField("outlined");
    case "material-standard":
      return renderTextField("standard");
    default:
      return renderTextField("filled");
  }
};

export default CurrencyInput;
